import { Icons } from '@agro-club/agroclub-shared'
import { refetchFunc } from 'modules/domain/common/hooks'
import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { APopoverButton } from 'views/components/Analytics/APopoverButton'
import { PopoverContainer } from 'views/styled/common'
import { CarEditModal } from '../../CarsKR/CarEditModal/CarEditModal'
import { CarStatuses, LogisticsKRCar } from '../../types'
import { ArchivedConfirmModal } from './ArchivedConfirmModal'
import { ToActiveConfirmModal } from './ToActiveConfirmModal'

type Props = {
  car: LogisticsKRCar
  onSuccess: refetchFunc
  setPopoverVisible: (arg: boolean) => void
}

export const PopoverContent: FC<Props> = ({ car, onSuccess, setPopoverVisible }) => {
  const { t } = useTranslation('logisticsKR')
  const [editModal, setEditModal] = useState(false)
  const [archivedConfirmModal, setArchivedConfirmModal] = useState(false)
  const [toActiveConfirmModal, setToActiveConfirmModal] = useState(false)

  return (
    <PopoverContainer
      width={170}
      onClick={(e) => {
        e.stopPropagation()
        setPopoverVisible(false)
      }}
    >
      <APopoverButton
        id="editCar"
        analyticsPayload={{ id: car.id }}
        text={t('carriers.popover.edit')}
        onClick={() => setEditModal(true)}
        Icon={<Icons.IconEdit />}
      />
      {car.status === CarStatuses.draft && (
        <APopoverButton
          id="changeToActive"
          analyticsPayload={{ id: car.id }}
          text={t('carriers.popover.change_to_active')}
          onClick={() => setToActiveConfirmModal(true)}
          Icon={<Icons.IconCheck />}
        />
      )}
      <APopoverButton
        id="changeToArchive"
        analyticsPayload={{ id: car.id }}
        text={t('carriers.popover.archived')}
        onClick={() => setArchivedConfirmModal(true)}
        Icon={<Icons.IconRemove />}
      />
      {editModal && <CarEditModal car={car} onClose={() => setEditModal(false)} onSuccess={() => onSuccess(true)} />}
      {archivedConfirmModal && (
        <ArchivedConfirmModal car={car} onSuccess={onSuccess} onClose={() => setArchivedConfirmModal(false)} />
      )}
      {toActiveConfirmModal && (
        <ToActiveConfirmModal onSuccess={onSuccess} car={car} onClose={() => setToActiveConfirmModal(false)} />
      )}
    </PopoverContainer>
  )
}
